<template>
  <div id="teacher-course" class="flex center">
    <div class="container">
      <!-- 面包屑 -->
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/online-learning',query:{menuid:$utils.addRoutePathByHeadMenu($route,$route,true)} }">在线学习</el-breadcrumb-item>
        <el-breadcrumb-item>学校管理人员课程</el-breadcrumb-item>
      </el-breadcrumb>
      <!-- 类目 -->
      <div class="classify flex container" :class="{'routate':isCollapse}">
        <p>所有类目：</p>
        <div class="button-group flex">
          <span
            class="button-item"
            v-for="(item,index) in courseClassList"
            :key="index"
            :class="{'button-item-active':$route.params.id == item.id}"
            @click="chooseClassify(item.id)">
            {{ item.className }}
          </span>
        </div>
        <div class="classify-collapse flex middle" @click="toogleClose">
          <span>{{ isCollapse ? '展开' : '收起' }}</span>
          <span><i class="el-icon-arrow-up"></i></span>
        </div>
      </div>
      <div class="section container flex bCenter">
        <el-radio-group v-model="params.ongoing">
          <el-radio-button label="">全部</el-radio-button>
          <el-radio-button :label="1">正在进行</el-radio-button>
          <!-- <el-radio-button :label="1">即将开始</el-radio-button> -->
          <el-radio-button :label="0">已结束</el-radio-button>
        </el-radio-group>
        <div>
          <el-input v-model="keyword" clearable placeholder="搜索课程" @clear="clearSearch" @keyup.native.enter="search">
            <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
          </el-input>
        </div>
      </div>
      <div class="content">
        <list :config="teacherCourseConfig" :dataList="filterDataList"></list>
      </div>
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="params.page"
        :page-sizes="[12, 20, 28, 36]"
        layout=" prev, pager, next, sizes, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import list from '@/components/list/list'
import carouselView from 'views/generalView/carouselView.vue'

import { getTrainingList, cloudGetCourseClass } from '@/service/api/methods/educationCloud';
import * as api_advertising from '@/service/api/methods/api_advertising'

export default {
  components:{
    list,
    carouselView,
  },
  data(){
    return{
      //是否展开
      isCollapse: true,
      //列表配置
      teacherCourseConfig: {
        showTitle: false,//是否显示头部
        list: '#F5F5F5',//列表背景色
        showTeacher: false,//是否展示教师信息
        showSchool:true,
      },
      filterDataList:[],
      //分类
      courseClassList:[],
      //总数
      total:0,
      //搜索课程名称
      keyword: '',
      //查询条件
      params:{
        type:1,
        page:1,
        rows:12,
        courseClassid:this.$route.params.id,
        ongoing:'',
        name:'',
      }
    }
  },
  watch:{
    params:{
      handler(newVal, oldVal){
        this.getTrainingList();
      },
      deep:true,
    },
  },
  created(){
    this.getCourseClass();
    this.getTrainingList();
  },
  methods: {
    //获取分类列表
    getCourseClass(){
      cloudGetCourseClass().then(
        res=>{
          if(res.success){
            this.courseClassList = res.data;
            this.courseClassList.unshift({id:0,className:"全部"});
          }
        },
      )
    },
    //获取在线培训列表
    getTrainingList(){
      let condition = JSON.parse(JSON.stringify(this.params));
      if(condition.courseClassid == 0){
        delete condition.courseClassid
      }
      getTrainingList(condition).then(
        res=>{
          if(res.code == 200){
            if(!this.$utils.isArrayEmpty(res.data)){
              res.data.forEach(item=>{
                item.cover = res.baseUrl + item.cover;
                item.linkUrl = `/online-learning/detail?pid=${item.id}`
              })
            }
            this.filterDataList = res.data;
            this.total = res.total;
          }
        }
      )
    },
    //选择分类
		chooseClassify(id){
      this.params.courseClassid = id;
			this.$router.push({
        params:{ 'id':id },
        query:this.$route.query
			})
    },
    //展开-关闭所有类目
    toogleClose(){
      this.isCollapse = !this.isCollapse;
    },
    // //筛选列表
    // filterList(){
    //   if(this.filterListCondition.classifyId.toString() == '' && this.filterListCondition.state.toString() == ''){
    //       this.filterDataList = this.teacherCourseData.list;
    //       return;
    //     }else{
    //       this.filterDataList = this.teacherCourseData.list.filter((item)=>{
    //       if(this.filterListCondition.state.toString() == ''){
    //         if(item.categoryId == this.filterListCondition.classifyId.toString()){
    //           return true;
    //         }
    //       }else if(this.filterListCondition.classifyId.toString() == ''){
    //         if(item.state == this.filterListCondition.state.toString()){
    //           return true;
    //         }
    //       }else{
    //         if(item.categoryId == this.filterListCondition.classifyId.toString() && this.filterListCondition.state.toString() == item.state){
    //           return true;
    //         }
    //       }
    //     })
    //   }
    // },
    // //搜索课程
    // search(){
    //   this.filterDataList = this.teacherCourseData.list
    //   let txt = this.className;
    //   let reg = new RegExp(`(${txt})`, 'ig');
    //   let searchDataList = JSON.parse(JSON.stringify(this.filterDataList))
    //   if(txt){
    //     this.filterDataList = searchDataList.filter((item)=>{
    //       if(item.title.indexOf(txt) != -1){
    //         item.title = item.title.replace(reg, `<span style="color: rgb(221, 220, 52);">${txt}</span>`)
    //         return true
    //       }
    //     })
    //   }else{
    //     this.filterDataList = this.filterDataList;
    //   }
    // },

    //搜索
    search(){
      this.params.name = this.keyword;
    },
    //清空搜索
    clearSearch(){
      this.params.name = '';
    },
    handleSizeChange(val) {
      this.params.rows = val;
    },
    handleCurrentChange(val) {
      this.params.page = val;
    }
  },
}
</script>

<style lang="less" scoped>
@import './teacherCourse.less';
</style>
